<template>
  <div id="common-sidebar" class="sidebar">
    <aside class="menu">
      <p class="menu-label">
        {{ $t('carshare.common.general') }}
      </p>
      <ul class="menu-list">
        <li v-for="(item, index) in items.children" :key="index">
          <div>
            <router-link
              v-if="!item.children"
              :to="{ name: item.route }"
              :class="{ 'is-active': activeItemRoute === item.route }"
              @click.native="routerChanged(item)"
            >
              <template v-if="item.data && item.data.icon"> <fa-icon :icon="item.data.icon" /> &nbsp; </template>
              {{ item.text }}
            </router-link>

            <div v-else>
              <a
                :class="{ 'is-active': openSubmenuIndex === index || isAnyChildActive(item) }"
                @click.prevent="toggleSubmenu(index)"
              >
                <span class="submenu-arrow">
                  <fa-icon :icon="openSubmenuIndex === index ? 'chevron-up' : 'chevron-down'" />
                </span>
                &nbsp;

                <template v-if="item.data && item.data.icon"> <fa-icon :icon="item.data.icon" /> &nbsp; </template>
                {{ item.text }}
              </a>

              <ul v-show="openSubmenuIndex === index">
                <li v-for="(child, cIndex) in item.children" :key="cIndex">
                  <router-link
                    :to="{ name: child.route }"
                    :class="{ 'is-active': activeItemRoute === child.route }"
                    @click.native="routerChanged(child)"
                  >
                    {{ child.text }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </aside>
  </div>
</template>

<script>
import authService from '@/common/services/auth';

export default {
  name: 'CommonSidebar',
  data() {
    return {
      items: { children: [] },
      openSubmenuIndex: null,
      activeItemRoute: null,
    };
  },
  watch: {
    '$route.name': function (newVal) {
      this.activeItemRoute = newVal;
    },
  },
  async mounted() {
    const lang = this.$route.query.lang || localStorage.getItem('lang');
    this.items = await authService.getMenu(lang);
    this.activeItemRoute = this.$route.name;
  },
  methods: {
    routerChanged(item) {
      this.activeItemRoute = item.route;
      this.$store.commit('SET_SIDEBAR_STATUS', false);
      this.$emit('selectedMenu', item.text);
    },
    toggleSubmenu(index) {
      this.openSubmenuIndex = this.openSubmenuIndex === index ? null : index;
    },
    isAnyChildActive(item) {
      if (!item.children) return false;
      return item.children.some((c) => c.route === this.activeItemRoute);
    },
  },
};
</script>
